import { RootState } from './rootReducer'

import { TypedUseSelectorHook, useSelector as useAppSelector, useDispatch as useAppDispatch } from 'react-redux'

export const useSelector: TypedUseSelectorHook<RootState> = useAppSelector
export const useDispatch = useAppDispatch
